import { AnimatePresence } from "framer-motion";
import { FC, useState } from "react";
import styled from "styled-components";

import Button from "@/components/Button";
import { PageHeading } from "@/components/Layout/Parts";
import Text from "@/components/Text";
import PostsTable from "./components/PostsTable";
import { ImageDistributionStatus } from "@/utils/enums";
import PostModal from "./components/PostModal";

const HeadingsRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 0;
`;

const NewProjectButton = styled(Button)`
  padding: 0 32px;
`;

interface Props {
  status?: ImageDistributionStatus;
}

const ImageDistribution: FC<Props> = ({ status }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Text $type="caption" $color="gray">
        EDITORIAL
      </Text>
      <HeadingsRow>
        <PageHeading>Image Distribution</PageHeading>
        <NewProjectButton onClick={() => setShowModal(true)}>
          New schedule
        </NewProjectButton>
      </HeadingsRow>
      <PostsTable status={status} />
      <AnimatePresence>
        {showModal && <PostModal onClose={() => setShowModal(false)} />}
      </AnimatePresence>
    </>
  );
};

export default ImageDistribution;
